<template>
  <page-section :title="$t('ProfileDevices_Title')">
    <rest-cards
      :fetch-endpoint="fetchEndpoint"
      :empty-text="$t('ProfileDevices_Text_NoData')"
    >
      <template slot-scope="{ item }">
        <device-preview-card :device="item" />
      </template>
    </rest-cards>
  </page-section>
</template>

<script>
import RestCards from '@/common/components/rest/RestCardsNew'
import PageSection from '@/common/components/page/PageSection'
import DevicePreviewCard from '@/modules/devices/components/DevicePreviewCard'
import { projectEndpoint } from '@/core/helpers'

export default {
  name: 'ProfileDevicesPage',

  components: {
    DevicePreviewCard,
    PageSection,
    RestCards
  },

  props: {
    profileId: {
      type: String,
      required: true
    }
  },

  computed: {
    fetchEndpoint() {
      let endpointParams = {
        profile_id: this.profileId
      }

      if (this.$hasFeature('allowAuthorisedDevices')) {
        endpointParams.expand = 'authorised'
      }

      return projectEndpoint({
        method: 'get',
        url: `devices`,
        params: endpointParams
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/profiles/pages/ProfileDevicesPage.vue